var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BoxBufferGeometry, } from "three";
import { Meshes } from "./Meshes";
var Boxes = /** @class */ (function (_super) {
    __extends(Boxes, _super);
    function Boxes(params, $paramObjArray) {
        var _this = _super.call(this, params) || this;
        // ------------------------------ Geometry
        _this.geometry = new BoxBufferGeometry(200, 95, 50);
        // ------------------------------ Meshes
        _this._createMeshes($paramObjArray);
        _this.scale.set(1, 1, 1);
        _this._onChangeScale();
        return _this;
    }
    return Boxes;
}(Meshes));
export { Boxes };
